module.exports = __webpack_public_path__ + "static/person3-cb90cbb29fd02391453eddaeb88e1a25.png";